var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerSvLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 607.219,
    height: 449.381,
    viewBox: "0 0 81.395 60.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 60.237h81.395V0H0v60.237z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e5cb3",
    d: "M1.914 58.466h77.569V1.773H1.912v56.693z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.49 30.118 40.699 5.327 15.906 30.118 40.7 54.91 65.49 30.117Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M56.046 30.118 40.698 14.767l-15.35 15.351 15.35 15.349 15.348-15.349Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m46.01 30.118-5.315-5.312-5.31 5.312 5.31 5.31 5.315-5.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerSvLogo);
export default __webpack_public_path__ + "static/media/Hamburger_SV_logo.93adb51fc329543594344adb7f1e3337.svg";
export { ForwardRef as ReactComponent };